{
  "auth": {
    "agree": "Acepto",
    "createAccount": "Crear cuenta",
    "createNewAccount": "Crear cuenta nueva",
    "email": "Email",
    "login": "Iniciar sesión",
    "password": "Contraseña",
    "recover_password": "Recuperar contraseña",
    "sign_up": "Registrar",
    "keep_logged_in": "Mantenerme conectado",
    "termsOfUse": "Términos de uso",
    "reset_password": "Restablecer contraseña"
  },
  "404": {
    "title": "Esta página se ha ido a pescar",
    "text": "Si crees que esto no es correcto, por favor envíanos un mensaje a ",
    "back_button": "Volver al tablero"
  },
  "typography": {
    "primary": "Estilos de texto primarios",
    "secondary": "Estilos de texto secundarios"
  },
  "dashboard": {
    "user_id": "ID de Usuario",
    "total_earned": "Total Ganado:",
    "balance": "Saldo",
    "total_earnings": "Ganancias Totales",
    "total_copy": "Total en CopyTrade",
    "affiliate_title": "Enlace de Afiliado",
    "affiliate_description": "Comparte este enlace exclusivo con otras personas y gana comisiones cada vez que alguien se registre y opere a través de él. ¡Es una excelente oportunidad para aumentar tus ingresos de forma simple y automática!",
    "copy": "Copiar",
    "finished_stakes": "Stakes Finalizadas",
    "running_stakes": "Stakes en Curso",
    "finished_copy": "CopyTrades Finalizados",
    "running_copy": "CopyTrades Activos",
    "finished_stakes_help": "Cantidad de stakes finalizadas.",
    "running_stakes_help": "Stakes en progreso.",
    "finished_copy_help": "Copytrades finalizados.",
    "running_copy_help": "Copytrades activos.",
    "latest_operations": "Últimas Operaciones",
    "vault_in_progress": "Vault en curso",
    "vault_help": "Inversiones activas en Vault",
    "bot_in_progress": "Inversión Zord en curso",
    "bot_help": "Inversiones activas mediante Zord",
    "view_all": "Ver todas",
    "date": "Fecha",
    "pair": "Par",
    "profit": "Ganancia",
    "latest_stakes": "Últimos 4 Stakes",
    "latest_copies": "Últimos 4 CopyTrades",
    "amount": "Monto",
    "pl": "P/G",
    "status": "Estado",
    "complete": "Completo",
    "versions": "Versiones",
    "setupRemoteConnections": "Configurar conexiones remotas",
    "currentVisitors": "Visitantes actuales",
    "charts": {
      "trendyTrends": "Tendencias modernas",
      "showInMoreDetail": "Mostrar en más detalle",
      "showInLessDetail": "Mostrar en menos detalle",
      "loadingSpeed": "Velocidad de carga",
      "topContributors": "Principales contribuyentes",
      "showNextFive": "Mostrar los siguientes cinco",
      "commits": "Commit"
    },
    "info": {
      "componentRichTheme": "Tema rico en componentes",
      "completedPullRequests": "Solicitudes de pull completadas",
      "users": "Usuarios",
      "points": "Puntos",
      "units": "Unidades",
      "exploreGallery": "Explorar galería",
      "viewLibrary": "Ver biblioteca",
      "commits": "Commits",
      "components": "Componentes",
      "teamMembers": "Miembros del equipo"
    },
    "tabs": {
      "overview": {
        "title": "Visión general",
        "built": "Construido con el framework Vue.js",
        "free": "Totalmente gratuito para todos",
        "fresh": "Diseño fresco y nítido",
        "mobile": "Responsivo y optimizado para móviles",
        "components": "Toneladas de componentes útiles",
        "nojQuery": "Totalmente libre de jQuery"
      },
      "billingAddress": {
        "title": "Dirección de facturación",
        "personalInfo": "Información personal",
        "firstName": "Nombre y apellido",
        "email": "Email",
        "address": "Dirección",
        "companyInfo": "Información de la empresa",
        "city": "Ciudad",
        "country": "País",
        "infiniteConnections": "Conexiones infinitas",
        "addConnection": "Añadir conexión"
      },
      "bankDetails": {
        "title": "Detalles del banco",
        "detailsFields": "Campos de detalles",
        "bankName": "Nombre del banco",
        "accountName": "Nombre de la cuenta",
        "sortCode": "Código de ordenación",
        "accountNumber": "Número de cuenta",
        "notes": "Notas",
        "sendDetails": "Enviar detalles"
      }
    },
    "navigationLayout": "Diseño de navegación",
    "topBarButton": "Barra superior",
    "sideBarButton": "Barra lateral"
  },
  "language": {
    "brazilian_portuguese": "Portugués brasileño",
    "english": "Inglés",
    "spanish": "Español",
    "simplified_chinese": "Chino simplificado",
    "persian": "Persa"
  },
  "menu": {
    "auth": "Autenticación",
    "buttons": "Botones",
    "timelines": "Líneas de tiempo",
    "dashboard": "Tablero",
    "billing": "Facturación",
    "login": "Iniciar sesión",
    "preferences": "Preferencias",
    "payments": "Pagos",
    "pricing-plans": "Planes de precios",
    "login-singup": "Iniciar sesión/Registrarse",
    "404": "Páginas 404",
    "faq": "FAQ"
  },
  "messages": {
    "all": "Ver todos los mensajes",
    "new": "Nuevos mensajes de {name}",
    "mark_as_read": "Marcar como leído"
  },
  "navbar": {
    "messageUs": "Preguntas sobre desarrollo web:",
    "repository": "Repositorio GitHub",
    "nova_stake": "Nueva Stake",
    "sacar": "Retirar",
    "trazer_corretora": "Traer de la Corredora",
    "saldo": "Saldo",
    "sair": "Salir",
    "historico": "Historial"
  },
  "sidebar": {
    "dashboard": "Inicio",
    "stake": "Stake",
    "history": "Historial",
    "network": "Red",
    "copytrade": "Copytrade",
    "operations": "Operaciones",
    "primezord": "Primezord",
    "primevault": "PrimeVault",
    "saldo_disponivel": "Saldo disponible",
    "voltar_corretora": "Volver a la Corredora",
    "tempo_sessao": "Tiempo restante de sesión"
  },
  "notifications": {
    "all": "Ver todas las notificaciones",
    "mark_as_read": "Marcar como leída",
    "sentMessage": "{name} te envió un mensaje",
    "uploadedZip": "{name} subió un archivo Zip con {type}",
    "startedTopic": "{name} inició un nuevo tema"
  },
  "user": {
    "language": "Cambiar Idioma",
    "logout": "Cerrar sesión",
    "profile": "Mi Perfil",
    "settings": "Configuración",
    "billing": "Facturación",
    "faq": "Preguntas Frecuentes",
    "helpAndSupport": "Ayuda & Soporte",
    "projects": "Proyectos",
    "account": "Cuenta",
    "explore": "Explorar"
  },
  "helpAndSupport": "Ayuda y Soporte",
  "aboutVuesticAdmin": "Acerca de Vuestic Admin",
  "search": {
    "placeholder": "Buscar..."
  },
  "vuestic": {
    "search": "Buscar",
    "noOptions": "No se encontraron elementos",
    "ok": "Aceptar",
    "cancel": "Cancelar",
    "uploadFile": "Subir archivo",
    "undo": "Deshacer",
    "dropzone": "Suelta los archivos aquí para subirlos",
    "fileDeleted": "Archivo eliminado",
    "closeAlert": "cerrar alerta",
    "backToTop": "volver al inicio",
    "toggleDropdown": "alternar menú desplegable",
    "carousel": "carrusel",
    "goPreviousSlide": "ir a la diapositiva anterior",
    "goNextSlide": "ir a la siguiente diapositiva",
    "goSlide": "ir a la diapositiva {index}",
    "slideOf": "diapositiva {index} de {length}",
    "close": "cerrar",
    "openColorPicker": "abrir selector de color",
    "colorSelection": "selección de color",
    "colorName": "color {color}",
    "decreaseCounter": "disminuir contador",
    "increaseCounter": "aumentar contador",
    "selectAllRows": "seleccionar todas las filas",
    "sortColumnBy": "ordenar columna por {name}",
    "selectRowByIndex": "seleccionar fila {index}",
    "resetDate": "restablecer fecha",
    "nextPeriod": "siguiente periodo",
    "switchView": "cambiar vista",
    "previousPeriod": "periodo anterior",
    "removeFile": "eliminar archivo",
    "reset": "restablecer",
    "pagination": "paginación",
    "goToTheFirstPage": "ir a la primera página",
    "goToPreviousPage": "ir a la página anterior",
    "goToSpecificPage": "ir a la página {page}",
    "goToSpecificPageInput": "ingresa el número de página",
    "goNextPage": "ir a la siguiente página",
    "goLastPage": "ir a la última página",
    "currentRating": "calificación actual {value} de {max}",
    "voteRating": "votar calificación {value} de {max}",
    "optionsFilter": "filtro de opciones",
    "splitPanels": "paneles divididos",
    "movePaginationLeft": "mover paginación a la izquierda",
    "movePaginationRight": "mover paginación a la derecha",
    "resetTime": "restablecer hora",
    "closeToast": "cerrar notificación",
    "selectedOption": "Opción seleccionada",
    "noSelectedOption": "No se ha seleccionado una opción",
    "breadcrumbs": "migas de pan",
    "counterValue": "valor del contador",
    "selectedDate": "fecha seleccionada",
    "selectedTime": "hora seleccionada",
    "progressState": "estado del progreso",
    "color": "color",
    "next": "Siguiente",
    "back": "Anterior",
    "finish": "Finalizar",
    "step": "paso",
    "progress": "progreso",
    "loading": "Cargando",
    "sliderValue": "El valor actual del control deslizante es {value}",
    "switch": "Cambiar",
    "inputField": "Campo de entrada",
    "fileTypeIncorrect": "El tipo de archivo es incorrecto",
    "select": "Seleccionar una opción"
  },
  "stakes": {
    "start_date": "Fecha de Contratación",
    "duration": "Plazo",
    "status": "Estado",
    "status_active": "En curso",
    "status_Finalizada": "Finalizada",
    "amount": "Monto de la Stake",
    "profit": "Ganancia Generada",
    "progress": "Progreso",
    "cancel_button": "Cancelar Stake",
    "modal_title": "Cancelar Stake",
    "modal_description": "¿Estás seguro de que deseas cancelar la stake por el valor de",
    "modal_close": "Cerrar",
    "modal_confirm": "Confirmar Cancelación"
  },
  "history": {
    "copytrade": "CopyTrade",
    "stakes": "Stakes",
    "operacoes": "Operaciones",
    "saques": "Retiros",
    "bonus": "Bono",
    "residual": "Residual",
    "primezord": "Primezord",
    "start_date": "Fecha de Inicio",
    "vault": "Vault",
    "end_date": "Fecha de Fin",
    "status": {
      "canceled": "Cancelado",
      "complete": "Completo",
      "expired": "Expirado",
      "in_progress": "En progreso",
      "finished": "Finalizada"
    },
    "columns": {
      "date": "Fecha",
      "value": "Valor",
      "progress": "Progreso",
      "status": "Estado",
      "invested": "Monto Invertido",
      "profit": "Ganancia Generada",
      "pair": "Par",
      "payout": "Pago",
      "description": "Descripción",
      "source": "Origen",
      "reference": "Referencia",
      "total": "Total",
      "percentage": "Porcentaje",
      "notes": "Notas"
    }
  },
  "network": {
    "email": "Correo",
    "phone": "Teléfono",
    "balance": "Saldo",
    "loading": "Cargando red..."
  },
  "copytrade": {
    "title": "CopyTrades Contratados",
    "create": "Crear Nuevo CopyTrade",
    "empty": "Ningún CopyTrade contratado actualmente.",
    "start_date": "Fecha de Inicio",
    "closed_notice": "Las inscripciones para nuevas copias están cerradas por el momento.",
    "status": "Estado",
    "status_active": "En curso",
    "status_expired": "Expirado",
    "invested": "Capital Invertido",
    "profit": "Ganancia Generada",
    "modal_title": "Crear nuevo CopyTrade",
    "modal_description": "Seleccione el monto que desea invertir.",
    "investment_amount": "Monto de la Inversión",
    "select": "Seleccione...",
    "start_copy": "Iniciar CopyTrade",
    "cancel": "Cancelar",
    "alert_select_amount": "Seleccione un monto"
  },
  "operations": {
    "start_date": "Fecha de Inicio",
    "end_date": "Fecha de Fin",
    "asset": "Activo",
    "all": "Todos",
    "loading": "Cargando operaciones...",
    "columns": {
      "date": "Fecha",
      "asset": "Activo",
      "payout": "Pago"
    }
  },
  "primezord": {
    "title": "Primezord",
    "deposit": "Depósito",
    "withdraw": "Retiro",
    "invest": "Inversión",
    "modal_deposit": "Realizar Depósito",
    "modal_withdraw": "Solicitar Retiro",
    "modal_invest": "Nueva Inversión",
    "modal_subtitle": "Seleccione el monto deseado.",
    "modal_value": "Monto",
    "modal_confirm": "Confirmar",
    "modal_cancel": "Cancelar",
    "balance_label": "Saldo Zord",
    "withdraw_balance_label": "Disponible para Retiro",
    "taxa": "Tasa del dólar",
    "table_date": "Fecha",
    "table_value": "Monto",
    "table_status": "Estado",
    "loading": "Cargando inversiones...",
    "blocked_balance_label": "Bloqueado",
    "alert_value": "Seleccione un monto"
  },
  "profile": {
    "title": "Actualizar Perfil",
    "avatarTitle": "Foto de Perfil",
    "selectImage": "Seleccione una imagen.",
    "saveAvatar": "Guardar Avatar",
    "personalInfo": "Información Personal",
    "phone": "Teléfono",
    "birth": "Fecha de nacimiento",
    "saveData": "Guardar Datos",
    "changePassword": "Cambiar Contraseña",
    "newPassword": "Nueva Contraseña",
    "confirmPassword": "Confirmar Contraseña",
    "savePassword": "Guardar Contraseña",
    "updatedSuccess": "Actualizado con éxito.",
    "updatedError": "Error al actualizar.",
    "passwordMismatch": "Las contraseñas no coinciden."
  },
  "primevault": {
    "title": "PrimeVault",
    "create": "Nuevo Vault",
    "empty": "Aún no has creado ningún PrimeVault.",
    "start_date": "Fecha de inicio",
    "status": "Estado",
    "status_active": "Activo",
    "status_expired": "Expirado",
    "invested": "Monto invertido",
    "profit": "Ganancia acumulada",
    "progress": "Progreso",
    "modal_title": "Nuevo PrimeVault",
    "modal_description": "Elige el monto para invertir e ingresa un código promocional si tienes uno.",
    "investment_amount": "Monto de inversión",
    "promocode": "Código promocional (opcional)",
    "select": "Selecciona un valor",
    "start": "Crear Vault",
    "cancel": "Cancelar",
    "alert_select_amount": "Por favor, selecciona un monto para invertir.",
    "filter_date": "Filtrar por fecha de inicio",
    "filter_min": "Monto invertido (mínimo)",
    "filter_max": "Monto invertido (máximo)",
    "order_progress": "Ordenar por progreso",
    "none": "Sin orden",
    "highest": "Mayor progreso",
    "lowest": "Menor progreso",
    "filter_status": "Filtrar por estado",
    "all_status": "Todos los estados",
    "reinvest": "Reinvertir",
    "reinvest_now": "Confirmar reinversión",
    "reinvest_title": "Reinvertir saldo disponible",
    "available_balance": "Saldo disponible",
    "reinvest_description": "Utiliza tu saldo disponible para reinvertir en un nuevo vault.",
    "reinvest_confirm": "Confirmar reinversión"
  }
}
